const layouts = {
  basic: {
    layer_1: {
      width: 310,
      height: 309,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 13,
      y: 275.5,
      index: 1,
    },
    layer_2: {
      width: 100,
      height: 100,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 20,
      y: 6,
      index: 2,
    },
    layer_3: {
      width: 488,
      height: 306,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 333.5,
      y: 276.5,
      index: 3,
    },
    layer_4: {
      width: 100,
      height: 100,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 220,
      y: 7,
      index: 4,
    },
    layer_5: {
      width: 100,
      height: 100,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 120,
      y: 125,
      index: 5,
    },
    layer_6: {
      width: 489,
      height: 258,
      minWidth: 10,
      minHeight: 10,
      type: '',
      draggable: true,
      resizable: true,
      backgroundColor: 'white',
      lockAspectRatio: false,
      x: 333.5,
      y: 7,
      index: 6,
    },
  },
}
export default layouts
